//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import LazyHydrate from 'vue-lazy-hydration'
import CopyrightContainer from '~/components/copyrightContainer'
import LoginModal from '~/components/modal/auth/login-modal'
import RegisterModal from '~/components/modal/auth/register-modal'
import GTM from '~/utils/classes/Gtm'
import SearchDestinationInputModal from '~/components/modal/search/search-destination-input-modal.vue'
import layout from '~/mixins/layout'

import IncomeModal from '~/components/modal/auth/income-modal'

export default {
  name: 'DefaultLayout',
  components: {
    IncomeModal,
    SearchDestinationInputModal,
    RegisterModal,
    LoginModal,
    CopyrightContainer,
    HeaderContainer: () => import('~/components/HeaderContainer'),
    FooterContainer: () => import('~/components/FooterContainer'),
    LazyHydrate
  },
  mixins: [layout],
  data () {
    return {
      gtm: new GTM(this.$gtm)
    }
  },
  mounted () {
    const data = window.localStorage.getItem('loginClosed')
    let allowPopup = true
    const date = new Date().getDate()
    if (data && data == date) {
      allowPopup = false
    } else if (data && data < date) {
      window.localStorage.removeItem('loginClosed')
      allowPopup = true
    }
    if (!this.user && allowPopup) {
      const timeout = this.locale === 'de' ? 300000 : 20000
      setTimeout(() => {
        if (!this.user && allowPopup) {
          this.$modal.show('income-modal')
        }
      }, timeout)
    }
    this.$nuxt.$on('popupclose', () => {
      document.getElementById('popups').classList.remove('visible')
    })
    this.$nuxt.$on('popup', (event) => {
      const el = document.getElementById(event)
      const pp = document.getElementById('popups')
      const rect = el.getBoundingClientRect()
      pp.innerText = el.dataset.popup
      pp.classList.add('visible')
      pp.style = `left: ${rect.x}px; top: ${rect.y + window.scrollY + 38}px;`
    })
  },
  computed: {
    ...mapState({
      loadCounters: 'useCounters',
      winSize: 'breakpoint'
    }),
    ...mapGetters({
      locale: 'lang/locale',
      currentLanguage: 'lang/currentLanguage',
      locales: 'lang/locales',
      loading: 'search/loading',
      user: 'auth/user',
      check: 'auth/check',
      getContactInfo: 'contact/getContactInfo'
    }),
    getPageName () {
      return this.$route.name?.split('.').join('_')
    },
    showButtons () {
      if (['booking-payment'].includes(this.$route.name)) {
        return false
      }
      return true
    }
  },
  jsonld () {
    const locale = this.$i18n.locale
    const contact = this.getContactInfo(locale)
    const phoneData = this.$store.state.contact.phoneNumbers
    let contacts = []
    for (const [key, p] of Object.entries(phoneData)) {
      contacts.push({
        '@type': 'ContactPoint',
        telephone: p[0].display,
        contactType: 'customer service',
        availableLanguage: key
      })
    }

    const cn = contact.country.code?.toUpperCase()
    return [
      {
        '@context': 'https://schema.org/',
        '@type': 'Organization',
        name: "Tubber",
        alternateName: ["Tubber.com", "Tubber Yacht Charters"],
        url: "https://www.tubber.com/" + locale + '/',
        logo: 'https://www.tubber.com' + '/v-images/logo.svg',
        contactPoint: [...contacts],
        sameAs: [ "https://www.facebook.com/TubberBoats/", "https://nl.pinterest.com/tubbercom/", "https://www.instagram.com/TubberBoats/"],
        address: {
          '@type': 'PostalAddress',
          streetAddress: this.$t('site-info_address'),
          addressLocality: contact.country?.translate?.name || '',
          addressRegion: this.$t('site-info_address-locality'),
          postalCode: this.$t('site-info_postal-code'),
          addressCountry: (cn === 'EN' ? 'GB' : cn) || 'NL'
        }
      },
      {
        '@context': 'https://schema.org/',
        '@type': 'WebSite',
        name: 'Tubber',
        url: 'https://www.tubber.com' + locale + '/',
        alternateName: ["Tubber.com", "Tubber Yacht Charters"],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: this.$t('about-us'),
        description: this.$t('the-yachts-are-ready-the'),
        url: 'https://www.tubber.com' + this.$router.resolve({ name: 'about' }).href
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ContactPage',
        name: this.$t('contact-us'),
        url: 'https://www.tubber.com/en/contact/',
        description: this.$t('we-re-here-to-help-feel'),
        mainEntityOfPage: 'https://www.tubber.com' + this.$router.resolve({ name: 'contact' }).href
      }
    ]
  },
  watch: {
    'check' () {
      if (!this.check) {
        if (this.$route?.meta?.authReq === true) {
          this.$router.replace({ name: 'index' })
        }
      }
    }
  }
}
